import {useContext} from 'react'
import _ from 'lodash';

import AppStateContext from "../app/context/appStateContext";
import ReactiveJob from '../app/interfaces/reactiveJob';
import PlannedJob from '../app/interfaces/plannedJob';
import Asset from '../app/interfaces/asset';
import moment from "moment";

export const tableData = {
  assets: {
    "Serial Number": 'SerialNo',
    "csvonly2": "ItemDescription",
    "csvonly1": "Condition",
    "Customer Code": 'CustomerCode',
    "Customer Reference 1": 'CUSTREF1',
    "Customer Reference 2": 'CUSTREF2',
    "Vendor": 'VENDOR',
    "Year Manufactured": 'YEARMAN',
    "Model": 'MODEL',
    "Item Code": 'ItemCode',
    "Invoice Amount": 'InvoiceAmount',
    "Invoice Number": 'InvoiceNo',
    "Invoice to date": 'InvoicedToDate',
    "Make": 'Make',
    "Serial Flag": 'SerialFlag',
    "Unit Quantity": 'UnitQty',
    "Unit Location": 'UnitLocation',
  },

  reactive: {
    "Fault Notes": 'FaultNotes',
    "Repair Notes": 'RepairNotes',
    "Call Number": 'CallNo',
    "csvonly1": "PriorityCode",
    'csvonly2': "Status",
    "Customer Name": 'CustomerName',
    "Customer Reference": 'CustomerReference',
    "Trade Type": 'Action',
    "Hold Reason": 'HoldReason',
    "Caller Name": 'CallerName',
    "Caller Contact Phone": 'CallerPhoneNo',
    "SLA Expected Onsite Date and Time": 'SLAOnsiteEstimatedDateTime',
    "SLA Actual Onsite Date and Time": 'SLAOnsiteActualDateTime',
    "SLA Expected Complete Date and Time": 'SLACompleteEstimatedDateTime',
    "SLA Actual Complete Date and Time": "SLACompleteActualDateTime",
    "Sales order number": 'SOOrderNo',
    "Sales order date": 'Date',
    "Total Amount Excluding Tax": 'OrderedAmountExTax',
  },

  planned: {
    "Call number": 'CallNo',
    "PM Call number": 'PMCallNo',
    "Contract number": 'ContractNo',
    "Customer code": 'CustomerCode',
    "Customer Reference 1": 'CUSTREF1',
    "Customer Reference 2": 'CUSTREF2',
    "Vendor": 'VENDOR',
    "Year Manufactured": 'YEARMAN',
    "Model": 'MODEL',
    "Unit location": 'UnitLocation',
    "Customer name": 'CustomerName',
    "Item description": 'ItemDescription',
    "Item code": 'ItemCode',
    "csvonly1": "Type",
    "csvonly2": "Procedure",
    "Routine": 'Routine',
    "Routine due date": 'RoutineDueDate',
    "Make code": 'MakeCode',
    "Make": "Make",
    "Serial Number": 'SerialNo',
    "Status": 'Status',
    "Reason": "Reason",
    "Reason code": "ReasonCode",
  }
};

// PORTAL-127. Exported standalone (not part of the hook) so it can be used anywhere the same
// "Generic" naming rule applies without needing a component to call filterHelper() for context it
// doesn't need. Kept as the single definition - src/app/components/Lists/cardList/index.tsx uses
// the same predicate for the per-job linked-asset list, which never goes through this page's
// pagination and still needs its own filter.
export const isGenericAsset = (item: Asset): boolean => Boolean(item?.ItemDescription?.toLowerCase().includes('generic'));

const filterHelper = () => {
  const { contractList, selectedCustomerId } = useContext(AppStateContext);

  const filterDataByContract = (data: []) => {
    let contracts;
    if(_.isArray(contractList[selectedCustomerId])) {
      contracts = contractList[selectedCustomerId];
    } else if(_.isObject(contractList[selectedCustomerId])) {
      contracts = Object.keys(contractList[selectedCustomerId]);
    }
    return data.filter((element: ReactiveJob | PlannedJob | Asset) => {
      return contracts.includes(element.ContractNo) && element.SerialNo != ""
    })
  };

  const filterByContractServices = (data: Asset[]) => {
    if(!_.isArray(data)) data = [data];
    return data.filter(asset => {
      return asset.ContractUnitNextServices != "";
    })
  };

  const filterByDate = (newDate: string, jobList: [], type: string) => {

    let datePeriod = getDatePeriod(newDate);

    return jobList.filter((job: ReactiveJob | PlannedJob) => {
      if(type == 'reactive') {
        return moment(job.ReceivedDatetime,'YYYY-MM-DD').isBetween(datePeriod.startDate,datePeriod.endDate,'second','[]');
      } else if (type == 'planned') {
        return moment(job.RunDueDate,'YYYY-MM-DD').isBetween(datePeriod.startDate,datePeriod.endDate,'second','[]');
      }
    });
  };

  const getDatePeriod = (newDate: string) => {
    let startDate = moment().subtract(10,'year');
    let endDate = moment().endOf('day');

    if(newDate == 'thisWeek') {
      startDate = moment().endOf('week').subtract(1,'week');
    } else if(newDate == 'thisMonth') {
      startDate = moment().startOf('month');
    } else if (newDate == 'last3Months') {
      startDate = moment().endOf('day').subtract(3,'month');
    } else if (newDate == 'last6Months') {
      startDate = moment().endOf('day').subtract(6,'month');
    } else if (newDate == 'last12Months') {
      startDate = moment().endOf('day').subtract(12,'month');
    } else if(newDate == 'today') {
      startDate = moment().startOf('day');
    }

    return {
      startDate,
      endDate,
    }
  };

  return {
    filterDataByContract,
    filterByContractServices,
    filterByDate,
    getDatePeriod,
  }
};

export default filterHelper;